import React from 'react';
import { Sparkle } from './Sparkle';
import { images } from '../data/content';
export function ProductIntro() {
  return <section aria-labelledby="intro-title" className="bg-kraft-light" data-id="element-133" data-mp="22mgi53r1gwbx">
      <div className="mx-auto grid max-w-6xl items-center gap-4 px-5 py-12 md:grid-cols-2 md:gap-10 lg:py-24" data-id="element-134" data-mp="1noo1g89ra1w5">
        <img src={images.cover} alt="Priority Journal cover on a spiral-bound kraft notebook" className="mx-auto -my-6 w-full max-w-[17rem] mix-blend-multiply sm:my-0 sm:max-w-sm md:order-2 md:max-w-md" data-id="element-135" data-mp="1smftd2aeho0c" />
        <div className="md:order-1" data-id="element-136" data-mp="2lav4veubpo6x">
          <p className="font-display text-lg font-medium italic text-kraft-dark" data-id="element-137" data-mp="2lb4zxgu86ljh">So let me introduce</p>
          <h2 id="intro-title" className="mt-2 flex flex-wrap items-center gap-3 font-display text-[2.5rem] font-black leading-none tracking-tight sm:text-6xl" data-id="element-138" data-mp="26kxm5ef5xqp4">
            <Sparkle className="h-7 w-7" data-id="element-139" data-mp="2zamobv3lzwsb" />
            The Priority Journal
          </h2>
          <p className="mt-6 text-xl font-medium leading-relaxed text-ink" data-id="element-140" data-mp="342o1dj8lprje">
            The simple method to organize your life without stress, focus on what really matters, and stop putting
            yourself last. For good.
          </p>
          <div className="mt-8 border-l-4 border-ink pl-5" data-id="element-141" data-mp="pehgwrj77h9v">
            <p className="font-display text-lg font-extrabold" data-id="element-142" data-mp="146jn0tbv36ic">It’s not a pretty journal to leave in a drawer.</p>
            <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-143" data-mp="ze01na6xn72z">
              It’s a real action tool, designed so that every day you know exactly what matters, what you can let go
              of, and how to move forward without feeling overwhelmed.
            </p>
          </div>
        </div>
      </div>
    </section>;
}